import { json } from './json';

let useHttp = false;

const setUseHttp = (use) => {
    useHttp = use;
};

const getProtocol = () => {
    return useHttp ? 'http' : 'https';
};

export default {
    useHttp: setUseHttp,
    protocol: getProtocol,

    get: (options, transformResponse) => {
        options.protocol = (options && options.protocol) || getProtocol();
        return json.get(options, transformResponse);
    },

    post: (options) => {
        options.protocol = options.protocol || getProtocol();
        return json.post(options);
    }
};
